"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.FileUpload = void 0;
const react_1 = __importDefault(require("react"));
const styled_components_1 = __importDefault(require("styled-components"));
const react_dropzone_1 = require("react-dropzone");
const button_1 = __importDefault(require("./button"));
const icon_1 = __importStar(require("./icon"));
const label_1 = __importDefault(require("./label"));
const styled_div_1 = __importDefault(require("./styled-div"));
const text_1 = __importDefault(require("./text"));
const theme_1 = __importDefault(require("../styles/theme"));
const getStateColor = (props) => {
    if (props.error) {
        return theme_1.default.colors.error;
    }
    if (props.isDragAccept) {
        return theme_1.default.colors.iconLogoAccent;
    }
    if (props.isDragReject) {
        return theme_1.default.colors.error;
    }
    if (props.isDragActive) {
        return theme_1.default.colors.primaryAccent;
    }
    return theme_1.default.colors.borderDefault;
};
const StyledDropZoneItem = styled_components_1.default.div `
  text-align: center;

  ${(props) => props.disabled &&
    `
    opacity: 0.7;
  `}
`;
const StyledPreviewList = styled_components_1.default.ul `
  list-style: none;
  margin: 1rem 0 0;
  padding: 0;
`;
const UploadContainer = styled_components_1.default.div `
  flex: 1;
  display: flex;
  flex-direction: ${(props) => (props.vertical ? 'column' : 'row')};
  align-items: center;
  justify-content: center;
  padding: 2rem;
  border-width: 2px;
  border-radius: 2px;
  border-color: ${(props) => getStateColor(props)};
  border-style: dashed;
  color: ${(props) => props.disabled
    ? props.theme.colors.textLight
    : props.theme.colors.borderDefault};
  transition: border 0.24s ease-in-out;

  ${StyledDropZoneItem} + ${StyledDropZoneItem} {
    margin-left: ${(props) => (props.vertical ? '0' : '3rem')};
    margin-top: ${(props) => (props.vertical ? '1rem' : '0')};
  }

  @media (max-width: 480px) {
    flex-direction: column;

    ${StyledDropZoneItem} + ${StyledDropZoneItem} {
      margin-left: 0;
      margin-top: 1rem;
    }
  }
`;
/**
 * A component that allows users to select files, either by dragging and dropping them into the component or
 * by clicking a button to browser their file system.
 */
const FileUpload = (_a) => {
    var { acceptTypes = 'image/*', ariaLabel, disabled = false, error = false, files = [], hint, id, label, maxFiles = 1, maxSize = 5242880, messages = {
        browseLabel: 'Browse Files',
        dragAndDropLabel: 'Drag and drop files here',
        or: 'or',
    }, onFilesChange, onFilesRejected, vertical = false } = _a, otherProps = __rest(_a, ["acceptTypes", "ariaLabel", "disabled", "error", "files", "hint", "id", "label", "maxFiles", "maxSize", "messages", "onFilesChange", "onFilesRejected", "vertical"]);
    const { getRootProps, getInputProps, isDragActive, isDragAccept, isDragReject, open, } = react_dropzone_1.useDropzone({
        accept: acceptTypes,
        disabled,
        maxFiles,
        maxSize,
        noClick: true,
        noKeyboard: true,
        onDrop: (acceptedFile, fileRejections) => {
            let updatedFiles = files.concat(acceptedFile);
            if (updatedFiles.length > maxFiles) {
                updatedFiles = updatedFiles.slice(0, maxFiles);
            }
            onFilesChange(updatedFiles);
            if (onFilesRejected) {
                onFilesRejected(fileRejections);
            }
        },
    });
    /* eslint-disable react/no-array-index-key */
    const previewFiles = files.map((uploadedFile, index) => (react_1.default.createElement("li", { key: `${uploadedFile.name}-${index}` },
        react_1.default.createElement(styled_div_1.default, { flex: true, borderColor: error ? theme_1.default.colors.error : theme_1.default.colors.borderDefault, padding: "s", marginBottom: "s" },
            react_1.default.createElement(text_1.default, null, uploadedFile.name),
            react_1.default.createElement(styled_div_1.default, { style: { marginLeft: 'auto' } },
                react_1.default.createElement(icon_1.IconButton, { disabled: disabled, name: "delete", onClick: () => {
                        const updatedFiles = files.slice();
                        updatedFiles.splice(index, 1);
                        onFilesChange(updatedFiles);
                    } }))))));
    /* eslint-enable react/no-array-index-key */
    // For accessibility, we cannot nest interactive elements (https://dequeuniversity.com/rules/axe/4.2/nested-interactive?application=axeAPI)
    // Thus we will avoid putting the `role` attribute on the container div. The user will be able to access the upload button to open the file dialog.
    const _b = getRootProps({
        isDragActive,
        isDragAccept,
        isDragReject,
    }), { role } = _b, dropzoneRootProps = __rest(_b, ["role"]);
    return (react_1.default.createElement("div", Object.assign({}, otherProps),
        label && (react_1.default.createElement(label_1.default, { error: error, htmlFor: id }, label)),
        files.length < maxFiles && (react_1.default.createElement(UploadContainer, Object.assign({ "data-testid": "file-upload-drop-zone-root", error: error, vertical: vertical }, dropzoneRootProps),
            react_1.default.createElement("input", Object.assign({ "aria-label": ariaLabel, "data-testid": "dropzone-file-input", disabled: disabled, id: id }, getInputProps())),
            react_1.default.createElement(StyledDropZoneItem, { disabled: disabled, vertical: vertical },
                react_1.default.createElement(icon_1.default, { name: "cloud_upload", size: "56px" }),
                react_1.default.createElement(text_1.default, { fontWeight: "medium", style: { display: 'block' } }, messages.dragAndDropLabel)),
            react_1.default.createElement(StyledDropZoneItem, { vertical: vertical },
                react_1.default.createElement(text_1.default, { color: theme_1.default.colors.textLight, fontWeight: "medium" }, messages.or)),
            react_1.default.createElement(StyledDropZoneItem, { vertical: vertical },
                react_1.default.createElement(button_1.default, { disabled: disabled, type: "button", onClick: open }, messages.browseLabel)))),
        files.length ? (react_1.default.createElement(StyledPreviewList, null, previewFiles)) : null,
        hint && (react_1.default.createElement(text_1.default, { fontSize: "xs", fontWeight: "normal", color: error ? theme_1.default.colors.error : theme_1.default.colors.textDefault }, hint))));
};
exports.FileUpload = FileUpload;
exports.default = exports.FileUpload;
